// extracted by mini-css-extract-plugin
export default {"main":"_ba-z"};